import React from "react";
import styled, { css } from "styled-components";

const SpacerStyles = styled.div`
  ${({ ...props }) => css`
    > * + * {
      margin-top: 24px;
    }
  `}
`;

export default function Spacer({ children }) {
  return <SpacerStyles>{children}</SpacerStyles>;
}
